import api from './api';

const getDocuments = (clientId, audited) => {
  const params = {};
  if (audited !== null && audited !== undefined) {
    params.audited = audited;
  }
  return api.get(`/documents/by-client/${clientId}`, { params });
};

const createDocument = (formData) => {
  return api.post('/documents/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const deleteDocument = (blobName) => {
  return api.delete('/documents/delete', {
    data: { blob_name: blobName }
  });
};

const deleteFolder = (folderName) => {
  return api.delete('/documents/delete/folder', {
    data: { folder_name: folderName }
  });
};

const createFolder = (clientId, relativePath) => {
  return api.post('/documents/folder/create', {
    client_id: clientId,
    relative_path: relativePath
  });
};

const getPublicUrl = (blobName) => {
  const bucketName = process.env.REACT_APP_S3_BUCKET_NAME;
  const region = process.env.REACT_APP_AWS_REGION;
  return `https://${bucketName}.s3.${region}.amazonaws.com/${blobName}`;
};

const downloadDocuments = (clientId) => {
  // This endpoint is not fully implemented in the backend for S3 yet,
  // but we keep the service function for UI consistency.
  // In a real scenario, this would trigger a backend process
  // to zip and provide a downloadable link.
  return api.get('/documents/download', {
    params: { client_id: clientId },
    responseType: 'blob',
  });
};

const getDocumentDateRange = (clientId) => {
  return api.get(`/documents/date-range/${clientId}`);
};

const documentService = {
  getDocuments,
  getDocumentDateRange,
  createDocument,
  deleteDocument,
  deleteFolder,
  createFolder,
  getPublicUrl,
  downloadDocuments,
};

export default documentService;